import AxiosStatic from "axios";
import store from "../store";
import BillingDetails from "./billing-details";
import { requests } from "./request";

class StripeSubscriptionService {
  $http = AxiosStatic;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getStripeConfig() {
    return this.$http
      .post("/api/StripeSubscription/StripeConfig")
      .then((response) => {
        if (response.data) {
          store.dispatch("setStripeConfig", response.data);
        } else {
          throw new Error("An unexpected error has occurred");
        }
      })
      .catch(this.formatErrorsAndRethrow);
  }

  activateSubscription(businessID: Number, subscriptionOptionID: number, billingDetails: BillingDetails) {
    return this.$http
      .post("/api/StripeSubscription/ActivateSubscription", { billingDetails, businessID, subscriptionOptionID })
      .then(async (response) => {
        if (response.data) {
          await store.dispatch("updateSubscriptionState");
          return response.data;
        } else {
          throw new Error("An unexpected error has occurred");
        }
      })
      .catch(this.formatErrorsAndRethrow);
  }

  reactivateSubscription(businessID: Number, billingDetails: BillingDetails) {
    return this.$http
      .post("/api/StripeSubscription/ReactivateSubscription", { billingDetails, businessID })
      .then(async (response) => {
        if (response.data) {
          await store.dispatch("updateSubscriptionState");
          return response.data;
        } else {
          throw new Error("An unexpected error has occurred");
        }
      })
      .catch(this.formatErrorsAndRethrow);
  }

  cancelSubscription(businessID: Number) {
    return this.$http
      .post("/api/StripeSubscription/CancelSubscription?businessID=" + businessID)
      .then((response) => {
        if (response) {
          //do nothing
        } else {
          throw new Error("An unexpected error has occurred");
        }
      })
      .catch(this.formatErrorsAndRethrow);
  }

  customerPortalRedirect() {
    return this.$http
      .post("/api/StripeSubscription/customerPortalRedirect")
      .then((response) => {
        if (response.data) {
          return response.data;
        } else {
          throw new Error("An unexpected error has occurred");
        }
      })
      .catch(this.formatErrorsAndRethrow);
  }

  async getBillingDetails(businessID: Number) {
    return this.$http
      .post("/api/StripeSubscription/getBillingDetails" + (businessID ? "?businessID=" + businessID : ""))
      .then((response) => {
        if (response.data) {
          store.dispatch("updateCancelled", response.data);
          return response.data;
        } else {
          throw new Error("An unexpected error has occurred");
        }
      })
      .catch(this.formatErrorsAndRethrow);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formatErrorsAndRethrow(error: any) {
    if (error.response) {
      let err = error.response.data;
      if (err.errors) {
        err = [
          ...Object.keys(error.response.data.errors).map(
            (key) => error.response.data.errors[key]
          ),
        ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        err = err.reduce((flat: any, list: any) => flat.concat(list));
        console.log(err);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        err = err.reduce((val: any, arr: any) => `${val} \r\n${arr}`, "");
      }
      throw new Error(err);
    } else {
      throw new Error("An unexpected error has occurred");
    }
  }
}

export default new StripeSubscriptionService();
